const _ = require('lodash');

const placementIdsFromSettings = ({ placIdField }, settings) => {
	const placementId = settings?.[placIdField] || '';
	return placementId.split('\n').map((s) => s.trim()).filter((s) => s);
};

const getIdsForPlacement = (adserver, { placement, settings, noLowerCase, ctx = {} }) => {
	const { id: adsId } = adserver;
	// These variables are cached in 'ctx' to avoid slow mongoose-property-accesses as this function might be
	// called a lot of times
	ctx[adsId] = ctx[adsId] || _.pick(adserver, [
		'useSspPlacementsForIds',
		'correspondingSspId',
		'placIdField',
	]);
	const vals = ctx[adsId];
	let ids;
	if (vals.useSspPlacementsForIds && vals.correspondingSspId) {
		ids = _.map(_.filter(placement.ssps, { source: vals.correspondingSspId }), 'id');
	}
	if (!ids || !ids.length) {
		ids = placementIdsFromSettings(vals, settings);
	}
	ids = _.filter(ids.map((id) => (noLowerCase ? id.trim() : id.trim().toLowerCase())));
	return ids;
};

module.exports = {
	placementIdsFromSettings,
	getIdsForPlacement,
};
